import { render, staticRenderFns } from "./comTable.vue?vue&type=template&id=3cfede20&scoped=true&"
import script from "./comTable.js?vue&type=script&lang=js&"
export * from "./comTable.js?vue&type=script&lang=js&"
import style0 from "./comTable.scss?vue&type=style&index=0&id=3cfede20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfede20",
  null
  
)

export default component.exports